import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Queue } from "./social/Queue";
import { Ready } from "./social/Ready";
import { Themes, Playbook, Chat, Settings } from "./social/Panels";

const TABS = ["Queue", "Ready to Post", "Chat", "Themes", "Playbook", "Settings"];

export function SocialAdmin() {
  const [tab, setTab] = useState("Queue");
  const [themes, setThemes] = useState([]);
  const [settings, setSettings] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  const loadThemes = () => api.get("/admin/social/themes").then(r => setThemes(r.data));
  const loadSettings = () => api.get("/admin/social/settings").then(r => setSettings(r.data));
  useEffect(() => { loadThemes(); loadSettings(); }, []);
  if (!settings) return null;
  const bump = () => setReloadKey(k => k + 1);
  return (
    <div data-testid="social-admin">
      <div className="mb-8">
        <h1 className="font-serif text-4xl mb-1">Social Studio</h1>
        <div className="overline text-white/40">Facebook + Instagram · every post needs your approval · learns from what performs</div>
      </div>
      <div className="flex flex-wrap gap-2 mb-8">
        {TABS.map(t => (
          <button key={t} type="button" onClick={() => setTab(t)} data-testid={`social-tab-${t.toLowerCase().replace(/\s+/g, "-")}`}
            className={`px-4 py-2 text-[11px] uppercase tracking-widest border ${tab === t ? "border-[#C77746] text-[#C77746]" : "border-white/15 text-white/60 hover:border-white/40"}`}>{t}</button>
        ))}
      </div>
      {tab === "Queue" && <Queue themes={themes.filter(t => t.active)} settings={settings} reloadKey={reloadKey} />}
      {tab === "Ready to Post" && <Ready settings={settings} reloadKey={reloadKey} />}
      {tab === "Chat" && <Chat onPostsCreated={bump} />}
      {tab === "Themes" && <Themes themes={themes} reload={loadThemes} />}
      {tab === "Playbook" && <Playbook />}
      {tab === "Settings" && <Settings settings={settings} onSaved={loadSettings} />}
    </div>
  );
}
